<template>
  <div class="transaction">
    <adx-sidebar />
    <div class="container-router">
      <div class="title">
        <h1 class="medium-title">Transaction History</h1>
        <ul class="title__menu">
          <router-link tag="li" :to="{name: 'transactiondigital'}">Digital Screen</router-link>
          <router-link tag="li" :to="{name: 'transactiondigitaladvertising'}">Digital Advertising</router-link>
          <!-- <router-link tag="li" :to="{name: 'transactionbus'}">Bus Advertising</router-link> -->
        </ul>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import TransactionItem from '@/views/Transaction/TransactionItem'
import SideBar from '@/components/SideBar/Desktop'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-',
  components: {
    'transaction-item': TransactionItem,
    "adx-sidebar": SideBar,
    'adx-loading': Loading,
    'adx-pagination': Pagination
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      currentPage: 1,
      maxPage: 1
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      (async () => {
        this.isLoading = true
        const params = {
          page: this.currentPage
        }
        const { data } = await api.get(apiV2.transactionHistory, { params, needToken: true })

        this.items = data.results
        this.maxPage = data.max_page
        this.isLoading = false
        
      })();
    },
    changePage (selected) {
      history.pushState(null, null, '?page=' + selected);
      this.currentPage = selected
      this.loadData()
      
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>